module.exports = __webpack_public_path__ + "static/media/giftsReceived_500_750.fb6f97e3.png";